import React, { Component } from "react";
import {Link} from "react-router-dom";
import * as Icon from "react-feather";
import {sessionUser, useKeycloak} from "../config";
import {BASE_URL} from "../auth/authConfig";
import ProjectHeader from "./ProjectHeader";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPx: 0
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollPos = window.scrollY;
    const visible = 64 - currentScrollPos > 0;
    const showPx = visible ? 0 - currentScrollPos : -64

    this.props.handleSetNavPx(showPx)
  };

  render() {
    let {navPx} = this.props;
    return (
      <nav className="topnav navbar navbar-expand shadow navbar-light bg-white sticky-top">
        <Link className="navbar-brand" to="/">
          <img src={process.env.PUBLIC_URL + "/mquark_logo.png"} />
        </Link>
        <button
          className="btn btn-transparent-dark order-2 order-lg-0 mr-lg-2"
          id="sidebarToggle"
          onClick={() => this.props.handleToggle()}
        >
          <Icon.Menu />
        </button>
        <ProjectHeader OnUpdate={this.props.OnUpdate} selectedProject={''}/>
        <ul className="navbar-nav align-items-center ml-auto">
          <li className="nav-item dropdown no-caret mr-2 dropdown-user">
            <a
              className="btn btn-transparent-dark dropdown-toggle"
              id="userDropdown"
              href="# "
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Icon.User size={23} />
            </a>
            <div
              className="dropdown-menu dropdown-menu-left border-0 shadow animated--fade-in-up"
              aria-labelledby="userDropdown"
            >
              <React.Fragment>
                <h6 className="dropdown-header d-flex align-items-center">
                  <div className="dropdown-user-details">
                    <div className="dropdown-user-details-name">
                      {sessionStorage.getItem(sessionUser) != null && JSON.parse(sessionStorage.getItem(sessionUser))['Username']}
                    </div>
                    <div className="dropdown-user-details-email">
                      {sessionStorage.getItem(sessionUser) != null && JSON.parse(sessionStorage.getItem(sessionUser))['Global_Role']}
                    </div>
                  </div>
                </h6>
                <div className="dropdown-divider"></div>
                {
                  !useKeycloak &&
                  <a href={BASE_URL + "Logout"} className="dropdown-item">
                    <div className="dropdown-item-icon">
                      <Icon.LogOut/>
                    </div>
                    Log Out
                  </a>
                }
                {
                  useKeycloak &&
                    <button className={'dropdown-item'} onClick={this.props.keycloakLogout}>
                      <div className="dropdown-item-icon">
                        <Icon.LogOut/>
                      </div>
                      Log Out
                    </button>
                }
              </React.Fragment>
            </div>
          </li>
        </ul>
      </nav>
    );
  }
}

export default NavBar;
